import angular from 'angular';
import URLS from 'Helpers/urls';
import moment from 'moment';

(function() {
    'use strict';

    angular.module('app').component('downloadApp', {
        template: require('./apply3.html'),
        controller: ApplyCtrl,
        controllerAs: 'vm'
    });

    ApplyCtrl.$inject = [
        '$scope',
        '$state',
        '$stateParams',
        '$location',
        '$rootScope',
        'ModalService',
        'QueryService',
        'SessionService',
        '$timeout',
        'logger',
        'Upload'
    ];

    function ApplyCtrl(
        $scope,
        $state,
        $stateParams,
        $location,
        $rootScope,
        ModalService,
        QueryService,
        SessionService,
        $timeout,
        logger,
        Upload
    ) {
        var vm = this;
        // important do not delete
        vm.user = SessionService.getUser();
        getData();
        function getData(){
            
            var req = {
                method: 'GET',
                route: { teacher: 'me' }, 
            };

            QueryService.query(req)
                .then(function(response) {
                    var data = response.data.data;
                    data.gototechcheck = 1;
                    console.log(JSON.stringify(data));
                                
                });
        }
        apply_now();
        function apply_now(){
            
            var modal = {
                page: 'download',
                titleHeader: ''
            };

            ModalService.form_modal('', modal, 'applyModal3').then(function(response) {
                $state.go('login', {});
            }, function(error) {
                $state.go('login', {});
                window.location = '/#!/login';
            });

        }

    }
})();



// WEBPACK FOOTER //
// ./src/app/components/apply3/download_app.component.js